import { useQuery } from '@tanstack/react-query';
import useApi from '../../../../../../../utils/AxiosWrapper';
import { useIsPreActiveCustomer } from '../../../../../../../hooks/useIsPreActiveCustomer';
import { getDemoTopPayers } from '../demoAccountingData';

export function useTopPayers(customerId: string, year: number, limit = 10) {
  const { callProtectedApi } = useApi();
  const isPreActive = useIsPreActiveCustomer();

  return useQuery({
    queryKey: ['accounting-top-payers', customerId, year, limit],
    queryFn: async () => {
      const params = new URLSearchParams({
        startDate: `${year}-01-01`,
        endDate: `${year + 1}-01-01`,
        limit: String(limit),
      });

      const response = await callProtectedApi(
        `/accounting/${customerId}/top-payers?${params.toString()}`,
        'get'
      );
      return response?.data?.data;
    },
    // See useIncomeStatement — demo data for pre-active, no request fired.
    enabled: !!customerId && !isPreActive,
    placeholderData: isPreActive
      ? () => getDemoTopPayers(year, limit)
      : undefined,
  });
}
